import { useThemes } from "../../contexts/ThemeContext";
import useLanguage from "../../hooks/useLanguage";
import { PopUp } from "./Popup";
import { useState } from "react";

export default function RefreshButton({
  onClick = () => {},
  lightMode,
  small,
  loading = false,
  noPop,
  dark,
  fullButton,
}) {
  const { themes, currentTheme } = useThemes();
  const { language } = useLanguage();
  const themeT = themes[currentTheme];
  const [popup, setPop] = useState(null);
  return (
    <>
      <button
        onClick={() => {
          //setPop({ title: language.REFRESHING, type: "refresh" });
          onClick();
        }}
        data-title={language.REFRESH}
        className={`${lightMode ? themeT.colors.borderColor : themeT.colors.activeBorder} border ${
          lightMode ? "" : themeT.colors.activeText
        } rounded-md  cursor-pointer active:scale-95  ${loading && !fullButton ? "" : ""}  ${dark && "shadow"} ${
          fullButton
            ? "flex flex-row-reverse justify-normal items-center p-1 md:px-4 md:py-2 gap-2"
            : "p-[7px]"
        }`}
        title={language.REFRESH}
      >
        {fullButton && <p className=" hidden md:block">{language.REFRESH}</p>}
        <svg
          stroke="currentColor"
          className={`${loading ? "animate-spin" : ""}  perspective-[1000px]`}
          fill="currentColor"
          strokeWidth="0"
          viewBox="0 0 512 512"
          height="21"
          width="21"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M256 388c-72.597 0-132-59.405-132-132 0-72.601 59.403-132 132-132 36.3 0 69.299 15.4 92.406 39.601L278 234h154V80l-51.698 51.702C348.406 99.798 304.406 80 256 80c-96.797 0-176 79.203-176 176s78.094 176 176 176c81.045 0 148.287-54.134 169.401-128H378.85c-18.745 49.561-67.138 84-122.85 84z"></path>
        </svg>
      </button>
      {popup != null && !noPop && (
        <PopUp
          unmount={() => setPop(null)}
          title={popup.title}
          type={popup.type}
        />
      )}
    </>
  );
}
